/* eslint-disable import/no-anonymous-default-export */
import _ from 'lodash';

export default (state = true, action) => {

  if (
    ['SET_SORT_BY_QUALYS_ASSETS', 'ADD_FILTER_QUALYS_ASSETS', 'DELETE_FILTER_QUALYS_ASSETS', 'RESET_FILTERS_QUALYS_ASSETS'].includes(action.type)
  ) {
    return true;
  }

  if (
    ['SET_QUALYS_ASSETS'].includes(action.type)
  ) {
    return false;
  }

  return state;
};